import { useEffect } from 'react';
import { useAppData } from '../../contexts/AppDataContext';
import { getDepartments } from '../../utils/departmentUtils';

/**
 * Utility component to synchronize departments between localStorage and AppDataContext
 * This component doesn't render anything, it just handles synchronization
 */
const DepartmentSynchronizer = () => {
  const { departments, setDepartments } = useAppData() || {};
  
  // Synchronize departments from localStorage to context when component mounts
  useEffect(() => {
    const syncDepartments = () => {
      try {
        const storedDepartments = getDepartments();
        
        if (setDepartments && Array.isArray(storedDepartments)) {
          console.log('DepartmentSynchronizer - Syncing departments to context:', storedDepartments);
          setDepartments(storedDepartments);
        }
      } catch (error) {
        console.error('Error syncing departments:', error);
      }
    };
    
    syncDepartments();
    
    // Listen for changes in localStorage
    const handleStorageChange = (e) => {
      if (e.key === 'stockpro_departments' || !e.key) {
        console.log('DepartmentSynchronizer detected storage change, syncing departments');
        syncDepartments();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('localStorageChange', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('localStorageChange', handleStorageChange);
    };
  }, [setDepartments]);
  
  // This component doesn't render anything
  return null;
};

export default DepartmentSynchronizer;